import { createContext } from 'react';

export const DEFAULT_CHECKOUT_FORM_STATE = {
  isDebouncing: false,
  isError: false,
  isFetching: false,
  query: '',
};

export type CheckoutFormState = typeof DEFAULT_CHECKOUT_FORM_STATE;

export type CheckoutFormStateAction =
  | { type: 'SET_DEBOUNCING'; payload: CheckoutFormState['isDebouncing'] }
  | { type: 'SET_ERROR'; payload: CheckoutFormState['isError'] }
  | { type: 'SET_QUERY'; payload: CheckoutFormState['query'] };

interface CheckoutFormContextType {
  state: CheckoutFormState;
  dispatch: React.Dispatch<CheckoutFormStateAction>; // Replace 'any' with the actual action type if you have one
}

const defaultContextValue: CheckoutFormContextType = {
  state: DEFAULT_CHECKOUT_FORM_STATE,
  dispatch: () => {},
};

export const CheckoutFormContext =
  createContext<CheckoutFormContextType>(defaultContextValue);
